import React from 'react';



class InicioBreadcrumbs extends React.Component {
	
	constructor(props) {
	    super(props);
	}
	

	
	render(){
		return <><a href = "" className = 'inicio'><i class="fas fa-home"></i></a></>
	}
	
	
	
	
	
}
export default InicioBreadcrumbs;